/**
 * @type {import('msw').RequestHandler[]}
 */
export const handlers = []
